import React from 'react';

import BaseComponentProperty from "../index";

export default class Link extends BaseComponentProperty {
    renderOwnProperties() {
        return (
            <div>
                <div>
                    <label>Image</label>
                    <textarea
                        value={this.props.component.data.image ? this.props.component.data.image : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            data.image = event.target.value;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Image alt</label>
                    <textarea
                        value={this.props.component.data.image_alt ? this.props.component.data.image_alt : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            data.image_alt = event.target.value;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Link</label>
                    <textarea
                        value={this.props.component.data.link ? this.props.component.data.link : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            data.link = event.target.value;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Title</label>
                    <input
                        type='text'
                        value={this.props.component.data.title ? this.props.component.data.title : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            data.title = event.target.value;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
            </div>
        );
    }
}
